import { PhoneIcon as Phone } from '@heroicons/react/outline';

export const PhoneIcon = () => (
  <Phone width="14" height="18" />
);
